// Feature "generare bilete cu cod".
// Vizibila pentru toate conturile; se poate bloca din /apanel
// (doc Firestore appSettings/codeGeneration -> { enabled: boolean }).
export const DEFAULT_CODE_GEN_ENABLED = true;
